import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import Button from "@mui/material/Button";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "universal-cookie";
import { addEWay } from "../../services/index";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Modal from "react-bootstrap/Modal";
import TextField from "@mui/material/TextField";

const EWay = () => {
  const [info, setInfo] = useState({
    eway_username: "",
    eway_password: "",
    eway_client_id: "",
    eway_client_secret: "",
    eway_grant_type: "",
    eway_access_token: "",
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleData = (e, key) => {
    if (e.value && e.label) {
      setInfo({
        ...info,
        [key]: e,
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSave = () => {
    const data = {
      organisationId: 1,
      settingsItem: [
        {
          key: "eway_username",
          value: info.eway_username,
        },
        {
          key: "eway_password",
          value: info.eway_password,
        },
        {
          key: "eway_client_id",
          value: info.eway_client_id,
        },
        {
          key: "eway_client_secret",
          value: info.eway_client_secret,
        },
        {
          key: "eway_grant_type",
          value: info.eway_grant_type,
        },
        {
          key: "eway_access_token",
          value: "",
        },
      ],
    };

    addEWay(data).then((res) => {
      if (res.errorCode == 0) {
      }
    });
  };


  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>E_Way Info</Modal.Header>
        <Modal.Body>
          <div className="modalForm">
            <div>
              {" "}
              <TextField
                variant="outlined"
                name="eway_username"
                label="User Name"
                onChange={(e) => handleData(e)}
              />{" "}
              <TextField
                variant="outlined"
                name="eway_password"
                label="Password"
                onChange={(e) => handleData(e)}
              />
            </div>
            <br />
            <div>
              {" "}
              <TextField
                variant="outlined"
                name="eway_client_id"
                label="Client Id"
                onChange={(e) => handleData(e)}
              />{" "}
              <TextField
                variant="outlined"
                name="eway_client_secret"
                label="Client Secret"
                onChange={(e) => handleData(e)}
              />
            </div>{" "}
            <br />
            <div>
              {" "}
              <TextField
                variant="outlined"
                name="eway_grant_type"
                label="Grant Type"
                onChange={(e) => handleData(e)}
              />{" "}
              {/* <TextField
                variant="outlined"
                name="eway_access_token"
                label="eway_access_token"
                onChange={(e) => handleData(e)}
              /> */}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <div style={{ height: 500, width: "100%" }}>
        <DataTable
          title="E_Way List"
          pagination
          fixedHeader
          pointerOnHover={true}
          highlightOnHover={true}
          subHeader
          subHeaderComponent={
            <>
              <Button variant="contained" onClick={() => setShow(true)}>
                <AddIcon />
                New
              </Button>
            </>
          }
        />
      </div>
      <Toaster />
    </>
  );
};

export default EWay;
